module.exports = __webpack_public_path__ + "static/media/3.2b41ebc1.png";